import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/module/carousel.css";

// import bg4 from "../../assets/images/img/bg-4.webp";

const slides = [
  {
    title: "Research and Analysis",
    desc: "We begin by understanding your business goals, user needs, and the market landscape. This helps us set a clear direction for the project.",
  },
  {
    title: "Planning and Strategy",
    desc: "Based on our research, we build a step-by-step plan outlining the development process, timelines, and required tools and technologies.",
  },
  {
    title: "Design",
    desc: "We craft intuitive wireframes and visual designs that bring your ideas to life, ensuring a smooth and engaging user experience.",
  },
  {
    title: "Development",
    desc: "With designs finalized, our team builds the app's frontend and backend, turning visuals into a working, high-quality product.",
  },
  {
    title: "Testing and Quality Check",
    desc: "We thoroughly test the app on different devices to catch bugs, improve performance, and ensure everything runs as expected.",
  },
  {
    title: "Deployment",
    desc: "Once everything is tested and approved, we publish your app to the appropriate platforms, making it available to users.",
  },
  {
    title: "Maintenance and Updates",
    desc: "After launch, we provide ongoing support, fix issues, and roll out updates to keep the app running smoothly and securely.",
  },
];

export default function WebMobileAppSlider() {
  useScrollReveal("slide-from-left");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");
  const settings = {
    dots: true, // Show dots
    infinite: false, // Do not loop infinitely
    speed: 500, // Slide animation speed
    slidesToShow: 3, // Show 3 slides at once
    slidesToScroll: 1, // Scroll one slide at a time
    swipeToSlide: true, // Allow drag/swipe
    arrows: false, // Show arrows
    responsive: [
      // Responsive settings for smaller screens
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="karuzela" className="section section__carousel">
      {/* <img
        className="container-bg image-background left slide-from-left"
        src={bg4}
        alt="container background"
        style={{ marginTop: "400px" }}
      /> */}
      <div className="container carousel">
        <h5 className="drop-from-top">step by step</h5>
        <div className="title flex drop-from-top">
          <h2 style={{ marginBottom: 30 }}>
            What does the Application Development process look like?
          </h2>
        </div>

        <div className="carousel-slider slick-initialized slick-slider slick-dotted slide-from-bottom">
          <div className="slick-list draggable">
            <Slider {...settings}>
              {slides.map((slide, index) => (
                <div key={index} className="card" style={{ padding: 10 }}>
                  <div className="card-element">
                    <h6 className="title">{slide.title}</h6>
                    <span className="desc mini">{slide.desc}</span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
